import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthService from "../../api/services/AuthService";
import "./referralTaskReminder.css";

const ONE_HOUR_MS = 60 * 1000;
const REFERRAL_TASKS_ROUTE = "/refer_earn";

/**
 * Global, login-only reminder. Polls referral-task-reminder on mount and every hour.
 * Shows a popup only while tasks are incomplete (completed === false); stays silent once done.
 */
export default function ReferralTaskReminderModal() {
  const navigate = useNavigate();
  const [visible, setVisible] = useState(false);
  const [reminder, setReminder] = useState(null);
  const timerRef = useRef(null);

  const checkReminder = useCallback(async () => {
    const token = localStorage.getItem("token");
    if (!token) {
      setVisible(false);
      setReminder(null);
      return;
    }
    try {
      const res = await AuthService.getReferralTaskReminder();
      const data = res?.data;
      if (res?.success && data && data.completed === false) {
        setReminder(data);
        setVisible(true);
      } else {
        setReminder(null);
        setVisible(false);
      }
    } catch {
      /* network/auth error: stay silent, retry on next cycle */
    }
  }, []);

  useEffect(() => {
    // referral-task-reminder API call temporarily disabled
    // checkReminder();
    // timerRef.current = setInterval(checkReminder, ONE_HOUR_MS);
    // return () => {
    //   if (timerRef.current) clearInterval(timerRef.current);
    // };
  }, [checkReminder]);

  const close = useCallback(() => setVisible(false), []);

  const goToTasks = useCallback(() => {
    setVisible(false);
    navigate(REFERRAL_TASKS_ROUTE);
  }, [navigate]);

  if (!visible || !reminder) return null;

  const message =
    (reminder.message && String(reminder.message).trim()) ||
    "Please complete your tasks to unlock your full referral rewards.";
  const completedCount = Number(reminder.completed_count) || 0;
  const totalTasks = Number(reminder.total_tasks) || 0;
  const pct = totalTasks > 0 ? Math.min(100, Math.round((completedCount / totalTasks) * 100)) : 0;

  return (
    <div className="rtr-overlay" role="dialog" aria-modal="true" aria-labelledby="rtr-title">
      <div className="rtr-modal">
        <button type="button" className="rtr-close" aria-label="Close" onClick={close}>
          <i className="ri-close-line" />
        </button>

        <div className="rtr-icon">
          <i className="ri-gift-2-line" />
        </div>

        <h4 id="rtr-title" className="rtr-title">
          Complete Your Tasks
        </h4>
        <p className="rtr-message">{message}</p>

        {totalTasks > 0 && (
          <div className="rtr-progress-wrap">
            <div className="rtr-progress-head">
              <span>
                {completedCount} of {totalTasks} completed
              </span>
              <span>{pct}%</span>
            </div>
            <div className="rtr-progress-track">
              <div className="rtr-progress-bar" style={{ width: `${pct}%` }} />
            </div>
          </div>
        )}

        <div className="rtr-actions">
          <button type="button" className="rtr-btn rtr-btn--ghost" onClick={close}>
            Later
          </button>
          <button type="button" className="rtr-btn rtr-btn--primary" onClick={goToTasks}>
            Complete Tasks
          </button>
        </div>
      </div>
    </div>
  );
}
